import { SideNavigationIconLink } from '../../../../../../../core/models/navigation-icon-link';
import { RouteConstants } from '../../../../../../../core/constants/routes';
import { AccessConstants } from '../../../../../../../core/constants/access-constants';
import { ExternalLinks } from '../../../../../../../core/constants/external-links';

export const getGoSideNavigationIconLinks = (): SideNavigationIconLink[] => {
    return goSideNavigationIconLinks;
};

const goSideNavigationIconLinks: SideNavigationIconLink[] = [
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Go.getFullRoute('overview'),
            text: 'Cevo Go Overview',
        },
        icon: {
            uri: 'assets/svg/click.svg',
            alt: 'Click icon',
        },
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Go.getFullRoute('purposeOfFiling'),
            text: 'New Cevo Go Application',
        },
        icon: {
            uri: 'assets/svg/new-document.svg',
            alt: 'New document',
        },
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Go.getFullRoute('fees'),
            text: 'Cevo Go Fees',
        },
        icon: {
            uri: 'assets/svg/calculate.svg',
            alt: 'Calculator',
        },
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Go.getFullRoute('help'),
            text: 'Cevo Go Help',
        },
        icon: {
            uri: 'assets/svg/help.svg',
            alt: 'Help icon',
        },
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Go.getFullRoute('about'),
            text: 'About Cevo Go',
        },
        icon: {
            uri: 'assets/svg/info.svg',
            alt: 'Information icon',
        },
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: RouteConstants.Dashboard.getFullRoute('INDEX'),
            text: 'Cevo Dashboard',
        },
        icon: {
            uri: 'assets/svg/dashboard.svg',
            alt: 'Dashboard',
        },
        // TODO: future ticket: open in new tab
    },
    {
        roles: AccessConstants.getAllUserRoles(),
        link: {
            url: ExternalLinks.enterpriseWireless.membership,
            text: 'EWA Membership',
            external: true,
        },
        icon: {
            uri: 'assets/svg/membership-badge.svg',
            alt: 'Membership',
        },
    },
];
